import { SET_JIO_BANNER_ADS } from '../../constants/constant';

const initialstate = {
  error: '',
  listingAds: [],
  facetValue: ''
};

export default function(state = initialstate, action) {
  const { type } = action;
  if (type === SET_JIO_BANNER_ADS) {
    const { values, error, facetValue } = action;
    console.log('🚀 ~ FETCHING_JIO_BANNER_ADS file jioAds.js');
    const nextState = { ...state, listingAds: values, error, facetValue };
    return nextState;
  }

  return state;
}
